import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class WalgreensRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    qs('.disclaimer')?.classList?.remove?.('hide')
    // store.resizeFn = this.onResize.bind(this);
    store.resizeFn = null
    store.section = 'home'

    this.setHeaderStyle('white')
    this.onPageChange()
    this.slideHome()
    this.setUpVideo()
  }

  onEnter() {
    super.onEnter()
    qs('.disclaimer')?.classList?.remove?.('hide')
    qs('.disclaimer')?.classList?.add?.('walgreens')
    qs('#header')?.classList?.add?.('no-bg')
  }

  onLeave() {
    super.onLeave()
    qs('.disclaimer')?.classList?.add?.('hide')
    qs('.disclaimer')?.classList?.remove?.('walgreens')
    qs('#header')?.classList?.remove?.('no-bg')
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    qs('.disclaimer')?.classList?.add?.('hide')
    super.onLeaveCompleted()
  }

  slideHome() {
    // if (store.bounds.ww > 900)
    setTimeout(() => {
      const $slideHomeContent = qsa('.h-s-i-back')
      var maxHeight = 0
      $slideHomeContent.forEach(($elem) => {
        if ($elem.offsetHeight > maxHeight) maxHeight = $elem.offsetHeight
      })
      $slideHomeContent.forEach(($elem) => {
        $elem.style.height = maxHeight + 'px'
      })
    }, 1000)

    const heroSlide = new Swiper('.hero-slide-text', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      loop: true,
      speed: 1000,
      // autoplay: {
      //     delay: 4000,
      //     waitForTransition: true,
      //     disableOnInteraction: false,
      // },
      navigation: {
        nextEl: '.h-s-next',
        prevEl: '.h-s-prev',
      },
      // breakpoints: {
      //     900: {
      //         autoplay: {
      //             delay: 5000,
      //             waitForTransition: true,
      //             disableOnInteraction: false,
      //         }
      //     }
      // },
      pagination: {
        el: '.hero-slide-dots',
        clickable: true,
        renderBullet: function (index, className) {
          const total = this.visibleSlidesIndexes
          const ariaLabel = `go to quote ${index + 1} out of ${total}`
          const ariaCurrent = index === 0 ? ' aria-current="true" ' : ''
          return (
            '<button ' +
            ariaCurrent +
            ' class="' +
            className +
            '" aria-label="' +
            ariaLabel +
            '">' +
            '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
            '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
            'stroke-opacity="1" stroke-width="1.5px"></circle>' +
            '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
            '</svg></button>'
          )
        },
      },
    })
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')

    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)
      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
          $mask.classList.add('active')
        }
      })
    })
  }
}

export default WalgreensRenderer
